import AsyncStorage from "@react-native-async-storage/async-storage"
import i18n from 'i18next';
import { CHECKIN_DEMO_FLOW, clientConfigPath, CMSPath, current_client_config, currentIP, DEMO_FLOW_ENABLED, GLOBAL_IV, GLOBAL_SALT, MOBILE_CHECKIN_CATEGORY, protocol } from "../../config/Constant"
import { documentListRequest, documentListSuccess } from "../Reducers/documentListReducer";
import { countryListtRequest, countryListtSuccess } from "../Reducers/countryListReducer";
import { sendAnalytics } from "./analyticsAction";
import { setProceedLoginToTheApp } from "./appConfigAction";
import { setGuestRoomData } from "../Reducers/guestRoomReducer";
import { setClientId, setConnectorIP, setInitAppLogout, setIsAutoLoggedIn, setShowLoginModal } from "../Reducers/appConfigReducer";
import { AesUtil } from "../../js/AesUtil";
import { setBookingStatus, setPreCheckInStatus } from "../Reducers/checkInReducer";
import i18next from "i18next";
import axios from "axios";
import { setRedirectInfo } from "../Reducers/deeplinkReducer";


export const fetchCheckInConfigs = async () => {
    try {
        const sessionToken = await AsyncStorage.getItem("sessionToken");
        const deviceIdentifier = await AsyncStorage.getItem("DeviceIdentifier");

        const response = await clientConfigPath.post(
            `/core/configsFetch?dId=${deviceIdentifier}`,
            {
                header: {
                    sessionToken,
                },
                payload: {
                    actionKey: "cardChecksData",
                },
            }
        );

        if (response.data && response.data.payload) {
            return { success: true, data: response.data.payload };
        } else {
            return { success: false, message: "No data payload found." };
        }
    } catch (error) {
        console.error("Error fetching check-in configs:", error.message || error);
        return { success: false, message: error.message || "An error occurred." };
    }
};


export const fetchPreCheckinForm = async () => {


    const defaultPreCheckInForm = [
        {
            "id": 4,
            "autoComplete": "email",
            "placeholder": "",
            "mandatory": true,
            "value": "",
            "fieldName": "Email",
            "type": "email",
            "fieldKey": "email"
        },
        {
            "id": 5,
            "min": 10,
            "max": 14,
            "autoComplete": "tel",
            "placeholder": "+000000000000",
            "mandatory": true,
            "value": "",
            "fieldName": "Mobile Phone Number",
            "type": "tel",
            "fieldKey": "phone"
        },
        {
            "id": 6,
            "mandatory": true,
            "fieldName": "Estimate time of Arrival",
            "type": "eta",
            "fieldKey": "eta"
        },
        {
            "id": 7,
            "openAddressDefault": true,
            "type": "address"
        },
        {
            "id": 8,
            "autoComplete": "",
            "placeholder": "Other Comments/Requests",
            "mandatory": false,
            "value": "",
            "fieldName": "Other Comments/Requests",
            "type": "text",
            "fieldKey": "specialRequests"
        }
    ]

    try {
        const headerConfig = {};
    
        const preCheckinformResponse = await fetch(
          `${CMSPath}/Connector/rest/assets?type=preCheckInForm`,
          headerConfig,
        );
    
        if (preCheckinformResponse.ok) {
          const data = await preCheckinformResponse.json();
          console.log('Successfully fetched precheckin form', data);
    
          if(data[0]?.formData){          
              return data[0]?.formData;
          } else {
            return defaultPreCheckInForm;
          }
        } else {
          console.log('Error while fetching precheckin form');
          return defaultPreCheckInForm;
        }
      } catch (error) {
        console.log('Error while fetching precheckin form');
        console.log(error);
        return defaultPreCheckInForm;
      }
};

export const getDocumentList = () => {

    return async (dispatch) => {
      dispatch(documentListRequest()); // Dispatch initial request action to indicate loading
  
      try {
        const sessionToken = await AsyncStorage.getItem('sessionToken');
        const deviceIdentifier = await AsyncStorage.getItem('DeviceIdentifier');
  
        if (!sessionToken || !deviceIdentifier) {
          throw new Error('Session Token or Device Identifier not found');
        }
  
        const response = await clientConfigPath.post(
          `/core/configsFetch?dId=${deviceIdentifier}`,
          {
            header: {
              sessionToken,
            },
            payload: {
              actionKey: 'guestDocListData',
            },
          }
        );
  
        // Check if response is valid
        if (response?.data?.payload) {
          dispatch(documentListSuccess(response?.data?.payload));
          return { success: true, data: response?.data?.payload };
        } else {
          throw new Error('No data payload found in the response');
        }
      } catch (error) {
        console.error('Error fetching document list:', error.message || error);
        return { success: false, message: error.message || 'An error occurred.' };
      }
    };
  };

  export const getCountryList = () => {

    return async (dispatch) => {
        try {

            dispatch(countryListtRequest()); // Dispatch the request to indicate loading

            const sessionToken = await AsyncStorage.getItem("sessionToken");
            const deviceIdentifier = await AsyncStorage.getItem("DeviceIdentifier");

            // Check if sessionToken and deviceIdentifier are available
            if (!sessionToken || !deviceIdentifier) {
                console.error('Session Token or Device Identifier is missing');
                return { success: false, message: "Session Token or Device Identifier is missing" };
            }

            const response = await clientConfigPath.post(
                `/core/configsFetch?dId=${deviceIdentifier}`,
                {
                    header: {
                        sessionToken,
                    },
                    payload: {
                        actionKey: "checkInAddressData",
                    },
                }
            );


            if (response.data && response.data.payload) {
                // Dispatch the success action with the data payload
                dispatch(countryListtSuccess(response?.data?.payload?.countries || []));

                return { success: true, data: response?.data?.payload?.countries || [] };
            } else {
                // If payload is not found, log the message
                console.log('No payload in the response');
                return { success: false, message: "No data payload found." };
            }
        } catch (error) {
            // Catch any errors and log them
            console.error("Error fetching country list:", error.message || error);
            return { success: false, message: error.message || "An error occurred." };
        }
    };
};


export const cardValidation = async (action, paylaod = {}) => {
    try {
        const sessionToken = await AsyncStorage.getItem("sessionToken");

        const requestPayload = {
            "header": {
                "sessionToken": sessionToken,
                "actionKey": action
            },
            "payload": paylaod
        }

        const response = await clientConfigPath.post(
            `/mobileCheckIn/cardValidation`, requestPayload
        );


        if (response?.data?.header?.status?.code == "SUCCESS") {
            return { success: true, data: response.data.payload };
        } else {
            return { success: false, message: "Something went wrong" };
        }
    } catch (error) {
        return { success: false, message: error?.response?.data?.header?.status?.msg };
    }
}

export const getAccompanyguestDynamicBookingForm = async () => {
    const defaultAccompanyDetaailsInForm = [
       {
           "id": 3,
           "autoComplete": "",
           "placeholder": "",
           "mandatory": true,
           "value": "",
           "fieldName": "Salutation",
           "type": "select",
           "fieldKey": "nameTitle",
           "option": [
               {
                   "displayName": "Mr.",
                   "value": "Mr."
               },
               {
                   "displayName": "Mrs.",
                   "value": "Mrs."
               },
               {
                   "displayName": "Ms.",
                   "value": "Ms."
               },
               {
                   "displayName": "Dr.",
                   "value": "Dr."
               },
               {
                   "displayName": "Miss",
                   "value": "Miss"
               }
           ]
       },
       {
           "id": 1,
           "autoComplete": "given-name",
           "placeholder": "",
           "mandatory": true,
           "value": "",
           "fieldName": "First Name",
           "type": "text",
           "fieldKey": "firstName"
       },
       {
           "id": 2,
           "autoComplete": "family-name",
           "placeholder": "",
           "mandatory": true,
           "value": "",
           "fieldName": "Last Name",
           "type": "text",
           "fieldKey": "lastName"
       }   
   ]

   try {
       const sessionToken = await AsyncStorage.getItem("sessionToken");

       const headerConfig = {
           headers: { Authorization: `Bearer ${sessionToken}` }
       };

       let response = await fetch(`${CMSPath}/Connector/rest/assets?type=preCheckInAccompanyGuestForm`, headerConfig)
       if (response.ok) {
           const bookingFromPayload = await response.json();
           if((bookingFromPayload[0]?.formData)){
               return bookingFromPayload[0]?.formData;
           }
           return defaultAccompanyDetaailsInForm;
       }else {
           console.log("Error while fetching accompany guest dynamic booking form");
           return defaultAccompanyDetaailsInForm;
       }
   } catch (err) {
       console.log("Got error while getting accompany guest dynamic booking form" + JSON.stringify(err))

       return defaultAccompanyDetaailsInForm;
   }
}


export const getDisclaimerText = async (disclaimerType, langCode, reservationNumber) => {
    try{
        let GuestJourneySessionToken = await AsyncStorage.getItem("sessionToken");

        const response = await clientConfigPath.get(
            `assets?fileType=html&type=${disclaimerType}&languageCode=${langCode}&reservationNumber=${reservationNumber}`, 
            {
                header: { 
                    Authorization: `Bearer ${GuestJourneySessionToken}` 
                }
            }
        )
        return {success: true, data: response?.data};
    } catch (error) {
        console.error("Error in fetch disclaimer text: ", error.message || error);
        const errorMessage = error?.response?.data?.header.status.msg || error.message || "Spomething went wrong";
        return { error: true, message: errorMessage };
    }
}


export const checkBookingStatus = (guestDetails = {}, widgetSessionId, pageName) => {


    return async (dispatch, getState) => {


        const { isOnline } = getState().appConfigSlice;
        if (!isOnline) {
            return { status: "FAILURE", response: null, message: i18n.t('offlineModal.subtitle')};
        }
        

        const { tempSelectedHotel } = getState().appConfigSlice;

        const { webAppWidgetsInfo } = getState().deviceConfigSlice;
        const { allowUserLoginViaFindingReservation, allowUserSelectLocation } = webAppWidgetsInfo?.appConfigs || {};

        const { isBookingFound, bookingData } = getState().checkInSlice.bookingStatus;

        const { lastName, checkinDate, confirmationNumber, flowIntent, roomNumber } = guestDetails;

        const { serverTimeDataObj } = getState().serverDateTimeSlice;




        if(allowUserSelectLocation && !tempSelectedHotel?.hotelPropertyKey && !isBookingFound) {
            return { status: "FAILURE", response: null, message: "No hotel selected. Please choose a hotel to continue." };
        }

        let sessionToken = tempSelectedHotel?.sessionToken ? tempSelectedHotel?.sessionToken : await AsyncStorage.getItem("sessionToken");

        let local_client_config = tempSelectedHotel?.hotelPropertyKey ? `GJ_${tempSelectedHotel?.hotelPropertyKey}` : current_client_config;
        let localIP = tempSelectedHotel?.hotelServerBaseUrl || currentIP;

        let local_clientConfigPath = axios.create({
            baseURL: localIP.startsWith("http")
              ? `${localIP}/Connector/rest`
              : protocol == 'http' ? `http://${localIP}:8080/Connector/rest` : `https://${localIP}:8443/Connector/rest`,
              timeout: 15000,
        })


        const handleBookingSuccess = async (dataPayload) => {
            await AsyncStorage.setItem("sessionConfirmationNumber", dataPayload?.confirmationNumber || "");
            await AsyncStorage.setItem("sessionReservationNumber", dataPayload?.reservationNumber || "");
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "BOOKING NUMBER - SUCCESS", { "element": "widget", "widgetSessionId": widgetSessionId, "pageName": pageName, "lastName": dataPayload.lastName, "checkinDate": dataPayload.checkinDate, "confirmationNumber": dataPayload.confirmationNumber }));

            let aesUtil = new AesUtil(128, 1000);

            const BOOKING_DATA = aesUtil.encrypt(
                GLOBAL_SALT,
                GLOBAL_IV,
                "1234567891234567",
                JSON.stringify(dataPayload)
            );

            const existingDataStr = await AsyncStorage.getItem("X_BOOKING_DATA_HOTEL_SPECIFIC_LIST");
            const existingData = existingDataStr ? JSON.parse(existingDataStr) : {};

            const BOOKING_DATA_HOTEL_SPECIFIC_LIST = {
                ...existingData,
                [local_client_config]: BOOKING_DATA,
            };

            await AsyncStorage.setItem("X_BOOKING_DATA_HOTEL_SPECIFIC_LIST", JSON.stringify(BOOKING_DATA_HOTEL_SPECIFIC_LIST));
            await AsyncStorage.setItem("connectorIP", localIP);
            await AsyncStorage.setItem("clientId", local_client_config);

            if(local_client_config !== current_client_config) {
                dispatch(setClientId(local_client_config));
                dispatch(setConnectorIP(localIP));

                dispatch(setInitAppLogout(true));

                return { status: "BOOKING_SUCCESS_ANOTHER_CONNECTOR", response:{
                    lastName: dataPayload.lastName?.trim().toLowerCase(),
                    checkinDate: dataPayload.checkinDate,
                    confirmationNumber: dataPayload.confirmationNumber?.trim() || "",
                    guestName: dataPayload?.guestName || dataPayload?.firstName + " " + dataPayload?.lastName,
                    ...dataPayload
                }, message: "Switching to your selected hotel"};
            } else {
                dispatch(setBookingStatus({
                    isBookingFound: true,
                    bookingData: dataPayload,
                }));

                if(dataPayload.isPreCheckInDone){
                    dispatch(preCheckInSuccessHandler(dataPayload));
                }


                return { status: "SUCCESS", response:{
                    lastName: dataPayload.lastName?.trim().toLowerCase(),
                    checkinDate: dataPayload.checkinDate,
                    confirmationNumber: dataPayload.confirmationNumber?.trim() || "",
                    guestName: dataPayload?.guestName || dataPayload?.firstName + " " + dataPayload?.lastName,
                    ...dataPayload
                }};
            }
        }


    
        const handleProceedLoginToTheApp = (lastName, confirmationNumber, checkinDate, roomNumber) => {

            let aesUtil = new AesUtil(128, 1000);

            dispatch(setIsAutoLoggedIn(true));
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "Auto Login - Attempted", {lastName, confirmationNumber, checkinDate, roomNumber}));

            if(local_client_config !== current_client_config) {

                let loginAuthToken = aesUtil.encrypt(GLOBAL_SALT, GLOBAL_IV, "1234567891234567", JSON.stringify({
                    lastName: lastName,
                    confirmationNumber: confirmationNumber,
                    checkinDate: checkinDate,
                    roomNumber: roomNumber
                }));

                let eventData = {
                    params: {
                        loginAuthToken: loginAuthToken,
                    }
                }

                dispatch(setClientId(local_client_config));
                dispatch(setConnectorIP(localIP));

                dispatch(setRedirectInfo(eventData));
                dispatch(setInitAppLogout(true));
            } else {
                dispatch(setProceedLoginToTheApp(true, { lastName, confirmationNumber, checkinDate, roomNumber}));
            }
        }


        if (DEMO_FLOW_ENABLED || CHECKIN_DEMO_FLOW) {

            const demoDetails = Array.isArray(i18next.t('check_in.demo_booking_data', { returnObjects: true }))  
            ? i18next.t('check_in.demo_booking_data', { returnObjects: true }) 
            : [];

            const bookingFound = demoDetails.find((item) => item.lastName.toLowerCase() === lastName?.trim().toLowerCase());
            if (bookingFound) {

                if(bookingFound?.guestCheckedIn || checkinDate < serverTimeDataObj?.date?.split("T")[0]){
                    handleProceedLoginToTheApp(bookingFound?.lastName, bookingFound?.confirmationNumber, bookingFound?.checkinDate, bookingFound?.roomNumber);
                    return { status: "LINKTOROOM", message: "Guest already checked in" };
                }

                return handleBookingSuccess({
                    lastName: lastName,
                    checkinDate: checkinDate,
                    confirmationNumber: confirmationNumber,
                    guestName: bookingFound.guestName || `${bookingFound.firstName} ${bookingFound.lastName}`,
                    ...bookingFound
                });
            }

            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "BOOKING NUMBER - FAILED", { "element": "widget", "widgetSessionId": widgetSessionId, "pageName": pageName, "errorMessage": "Booking not found with provided details.", "lastName": lastName, "checkinDate": checkinDate, "confirmationNumber": confirmationNumber }));
            return { status: "FAILURE", response: null, message: "Booking not found with provided details." };
        }

        
    try {

        // Validate required fields
        if (!lastName || !checkinDate) {
            return { success: false, message: "Please provide your last name and check-in date." };
        }

        const formData = new FormData();
        formData.append("sessionToken", sessionToken);
        formData.append("lastName", lastName.trim().toLowerCase());
        formData.append("checkinDate", checkinDate);
        formData.append("confirmationNumber", confirmationNumber?.trim() || "");
        formData.append("actionKey", "bookingDataEnquiry");
        formData.append("checkInType", "precheckin");

        if(flowIntent) formData.append("flowIntent", flowIntent);
        if(flowIntent == "login") formData.append("roomNumber", roomNumber || null);


        const headers = {
            headers: { 'Content-Type': 'multipart/form-data' }
        }

        const response = await local_clientConfigPath.post(
            `/mobileCheckIn/guestBooking`, formData, headers
        );


        if (response.data && response.data.payload) {
            return handleBookingSuccess({
                lastName: lastName?.trim().toLowerCase(),
                checkinDate: checkinDate,
                confirmationNumber: confirmationNumber?.trim() || "",
                guestName: response.data.payload?.guestName || response.data.payload?.firstName + " " + response.data.payload?.lastName,
                ...response.data.payload
            })
        } else {

            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "BOOKING NUMBER - FAILED", { "element": "widget", "widgetSessionId": widgetSessionId, "pageName": pageName, "errorMessage": "Booking not found with provided details.", "lastName": lastName, "checkinDate": checkinDate, "confirmationNumber": confirmationNumber }));
            return { status: "FAILURE", response: response?.data, message: "Booking not found with provided details." };
        }
    } catch (error) {

        const response = error?.response?.data;
        const errorMessage = error?.response?.data?.header.status.msg

        dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "BOOKING NUMBER - FAILED", { "element": "widget", "widgetSessionId": widgetSessionId, "pageName": pageName, "errorMessage": errorMessage, "lastName": lastName, "checkinDate": checkinDate, "confirmationNumber": confirmationNumber }));

        // login.
        if(response?.header?.status?.guestCheckedIn && response?.header?.status?.roomNumber){
            handleProceedLoginToTheApp(lastName, confirmationNumber, checkinDate, response?.header?.status?.roomNumber);
            return { status: "LINKTOROOM", response: response, message: error?.response?.data?.header.status.msg };
        }

        // inHouseAndDueInConflict - show login popup and check for flowintent
        if(response?.payload?.inHouseAndDueInConflict){
            dispatch(setGuestRoomData({
                guestDetails: guestDetails,
                activeState: 'inHouseAndDueInConflict',
                widgetSessionId: widgetSessionId,
            }));
            dispatch(setShowLoginModal(true));
            return { status: "inHouseAndDueInConflict", response: response, message: error?.response?.data?.header.status.msg };
        }
        
        // multipleInHouseConflict - show login popup and ask for room number
        if(response?.payload?.multipleInHouseConflict){
            dispatch(setGuestRoomData({
                guestDetails: guestDetails,
                activeState: 'multipleInHouseConflict',
                widgetSessionId: widgetSessionId,
            }));
            dispatch(setShowLoginModal(true));
            return { status: "multipleInHouseConflict", response: response, message: error?.response?.data?.header.status.msg };
        }

        // multipleDueInConfict - show login popup and ask for confirmation number
        if(response?.payload?.multipleDueInConfict){
            dispatch(setGuestRoomData({
                guestDetails: guestDetails,
                activeState: 'multipleDueInConfict',
                widgetSessionId: widgetSessionId,
            }));
            dispatch(setShowLoginModal(true));
            return { status: "multipleDueInConfict", response: response, message: error?.response?.data?.header.status.msg };
        }

        return { status: "FAILURE", response: response, message: error?.response?.data?.header.status.msg };
    }}
};


export const preCheckInSuccessHandler = (preCheckInDataPayload={}, hasCompletedPreCheckInViaDevice=false) => {
    console.log("in preCheckInSuccessHandler", preCheckInDataPayload, hasCompletedPreCheckInViaDevice);
    

    return async (dispatch, getState) => {
        let aesUtil = new AesUtil(128, 1000);
        
        // Encrypt data
        const CHECKIN_PQ_DATA = aesUtil.encrypt(
            GLOBAL_SALT,
            GLOBAL_IV,
            "1234567891234567",
            JSON.stringify(preCheckInDataPayload)
        );

        const existingDataStr = await AsyncStorage.getItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST");
        const existingData = existingDataStr ? JSON.parse(existingDataStr) : {};


        const CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST = {
            ...existingData,
            [current_client_config]: CHECKIN_PQ_DATA,
        };

        // Handle platform-specific storage
        // if (!isWeb() && hasCompletedPreCheckInViaDevice) { -> request change to not ask confirmation number even on web.
        await AsyncStorage.setItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST", JSON.stringify(CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST));

        await AsyncStorage.setItem("connectorIP", currentIP);
        await AsyncStorage.setItem("clientId", current_client_config);

        // Dispatch updated status
        dispatch(setPreCheckInStatus({
            preCheckInCompleted: true,
            preCheckInData: preCheckInDataPayload,
        }));
    }
}